import Vue from 'vue'
import vuex from 'vuex'

Vue.use(vuex);

import app from './modules/app'
import hear from './modules/hear'
import iframe from './modules/iframe'
import user from './modules/user'
import menu from './modules/menu'

const store = new vuex.Store({
    modules: {
        app: app,
        hear: hear,
        iframe: iframe,
        user: user,
        menu: menu
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js